module.exports = __webpack_public_path__ + "img/plane.10d8dab7.svg";